import { Component, OnInit } from '@angular/core';
import { SearchService } from './../../services/search.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  public searchItens;

  constructor(
    private _search: SearchService,
    private _router: Router
  ) { }

  ngOnInit() {
    this._search.searchList.subscribe(searchList => this.searchItens = searchList);
  }

  searchRoute(param) {
    this._router.navigate(['/catalogo'], {skipLocationChange: true}).then(() => {
      this._router.navigate(['/catalogo/artigos', param]);
    });
  }
}
